const FALLBACK_PROVIDER_ICON = '/static/image/other/vector.svg';

const uniq = (items) => Array.from(new Set(items.filter(Boolean)));

const trimPlatform = (platform) => String(platform ?? '').trim();

const platformVariants = (platform) => {
  const raw = trimPlatform(platform);
  if (!raw) return [];

  const noSpaces = raw.replace(/\s+/g, '');
  const underscore = raw.replace(/\s+/g, '_');
  const dash = raw.replace(/\s+/g, '-');

  // Many providers use exact casing (e.g. DreamGaming), but some may come with spaces.
  // We keep the raw form first, then try common filename-safe variants.
  return uniq([
    raw,
    noSpaces,
    underscore,
    dash,
    raw.toUpperCase(),
    raw.toLowerCase(),
  ]);
};

const apiBaseNormalized = (apiBase) => {
  const base = String(apiBase ?? '').trim();
  return base.endsWith('/') ? base.slice(0, -1) : base;
};

export const providerLogoCandidates = (
  platform,
  apiBase = process.env.REACT_APP_API_URL,
) => {
  const base = apiBaseNormalized(apiBase);
  if (!base) return [FALLBACK_PROVIDER_ICON];

  const variants = platformVariants(platform);
  const urls = variants.map(
    (v) => `${base}/provider/${encodeURIComponent(v)}.png`,
  );

  // Always end with a local fallback so the UI never shows a broken image icon.
  return uniq([...urls, FALLBACK_PROVIDER_ICON]);
};

export const providerLogoUrl = (platform, apiBase) =>
  providerLogoCandidates(platform, apiBase)[0];

export const providerLogoBackgroundImage = (platform, apiBase) => {
  // CSS supports multiple background images; if the first 404s, the next can render.
  // Keep this list short to avoid extra requests.
  const candidates = providerLogoCandidates(platform, apiBase).slice(0, 3);
  return candidates.map((u) => `url("${u}")`).join(', ');
};
